import React from 'react';
import classnames from 'classnames';
import { SecondaryBody } from 'scy/text';
import { getFBAvatar } from 'shared/models/user';
import styles from './styles.mod.scss';

export default function UserAvatar(props) {
  const fbAvatar = getFBAvatar(props.user, props.large);
  return fbAvatar ? (
    <Avatar src={fbAvatar} {...props} />
  ) : (
    <Initial {...props} />
  );
}

export function Avatar({ src, large = false, className }) {
  return (
    <img
      src={src}
      className={classnames(
        styles.avatar,
        { [styles.avatarLarge]: large },
        className
      )}
    />
  );
}

export function Initial({
  user,
  large = false,
  includeLastInitial = false,
  className
}) {
  const initials =
    (user.firstname || '').slice(0, 1) +
    (includeLastInitial ? (user.lastname || '').slice(0, 1) : '');

  return (
    <SecondaryBody
      uppercase
      className={classnames(
        styles.avatar,
        { [styles.avatarLarge]: large },
        className
      )}
    >
      {initials}
    </SecondaryBody>
  );
}
